// extracted by mini-css-extract-plugin
module.exports = {"chartTitle":"OperationalSensorChartContainer_chartTitle__3240b","marginTop":"OperationalSensorChartContainer_marginTop__rhHgL"};